<template>
    <a
        class="dropdown-trigger min-h-dropdown-trigger flex items-center cursor-pointer select-none"
        :class="{ 'active': active }"
        @click="handleClick"
    >
        <slot />
    </a>
</template>

<script>
    export default {
        props: {
            handleClick: {
                type: Function,
                required: true,
            },
            active: {
                type: Boolean,
                default: false,
            },
            showArrow: {
                type: Boolean,
                default: true,
            },
        },
    };
</script>
